import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

import { useBranding } from "client/hooks";

const useStyles = makeStyles((theme: Theme) => ({
  factBody: {
    color: theme.palette.common.white,
  },
  factHeader: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.white,
  },
  dataFactWrapper: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "45%",
    },
    [theme.breakpoints.down("sm")]: {
      margin: `0 ${theme.spacing(3)}px ${theme.spacing(3)}px `,
    },
  },
  dataFactsWrapper: {
    backgroundColor: theme.palette.common.black,
    height: "100%",
    padding: `${theme.spacing(3)}px 0`,
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
    },
  },
}));

const DataFact: React.FC<{
  header: string;
  body: string;
}> = ({ header, body }) => {
  const classes = useStyles();
  return (
    <Box className={classes.dataFactWrapper} mb={4}>
      <Typography variant="h2" className={classes.factHeader}>
        {header}
      </Typography>
      <Typography className={classes.factBody} variant="body2">
        {body}
      </Typography>
    </Box>
  );
};

export const DataFacts: React.FC = () => {
  const { brandTitle } = useBranding();
  const classes = useStyles();
  return (
    <Box
      alignItems="center"
      className={classes.dataFactsWrapper}
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <DataFact
        header="30%"
        body={`Our retailers find that 30% or more of ${brandTitle} shoppers are new to their brand.`}
      />
      <DataFact
        header="40%"
        body="Stores that welcome our members can boost average order values by up to 40%. "
      />
      <DataFact
        header="22%"
        body={`${brandTitle} can grow cart conversions by up to 22%—plus more repeat shoppers.`}
      />
    </Box>
  );
};
